var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237 198L237 226",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 237.5,
    cy: 193.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.987 193.19C232.987 189.283 236.288 186.117 240.358 186.117C240.943 186.117 241.511 186.184 242.056 186.308C240.742 185.48 239.187 185 237.519 185C232.814 185 229 188.806 229 193.5C229 198.194 232.814 202 237.519 202C239.814 202 241.895 201.093 243.427 199.62C242.492 200.032 241.454 200.263 240.358 200.263C236.288 200.263 232.987 197.096 232.987 193.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M246.402 192.6L246.37 190.146L244.536 191.719L242.304 191.056L243.112 193.337L241.765 195.381L244.1 195.218L245.499 197.144L246.133 194.763L248.345 193.909L246.402 192.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch7);
export default __webpack_public_path__ + "static/media/church_7.96c157854ffe1df9016551dea31d57fa.svg";
export { ForwardRef as ReactComponent };